import { Grid } from "@scuf/common";
import "./PAcido.css";
import ProduccionAcido from "./components/produccionAcido";
import Lecho4PAS from "./components/lecho4PAS";
import Lecho3PAS from "./components/lecho3PAS";
import Lecho2PAS from "./components/lecho2PAS";
import Lecho1PAS from "./components/lecho1PAS";
import GasesAConversion from "./components/gasesAConversion";
import ChimeneaPAS from "./components/chimeneaPAS";

export default function PAcido() {
  return (
    <>
    <Grid>
      <Grid.Row className="tostador-row">
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <ProduccionAcido/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <GasesAConversion/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <Lecho1PAS/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <Lecho2PAS/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <Lecho3PAS/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <Lecho4PAS/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <ChimeneaPAS/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </>
  );
}
